import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"

interface TokenPayload {
    rol?: string
    exp?: number
    iat?: number
}

interface PrivateAdminRouterProps {
    children: ReactNode
}

const PrivateAdminRouter = ({ children }: PrivateAdminRouterProps) => {
    const token = localStorage.getItem("jwt")

    if (token && token !== "undefined") {
        try {
            const token_decode = jwtDecode<TokenPayload>(token)

            if (token_decode.rol === "admin") {
                return <>{children}</>
            } else {
                return <Navigate to="/logout" />
            }
        } catch (error) {
            console.error("Error decoding token:", error)
            return <Navigate to="/logout" />
        }
    } else {
        return <Navigate to="/logout" />
    }
}

export default PrivateAdminRouter
